import {HTTP} from '@/services/HttpServices';
import {SportEventSummary} from "@/models";

export function getBannerEvents(): Promise<SportEventSummary[]> {
    return HTTP.get("/public/events/banner-events");
}
